import { selectChapter } from 'affiny-core/redux/selectors/reflistsSelectors';
import { connect } from 'react-redux';
import { IRootState } from '../../state';

interface IOwnProps {
  chapterLabel: string;
}

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => ({
  chapter: selectChapter(state, ownProps.chapterLabel),
});

export type IChapterContainerProps = ReturnType<typeof mapStateToProps>;

export const chapterContainerFactory = connect(mapStateToProps);
